import { ClientDetailsModel } from './client-details.model';
import { YearDataModel } from './year-data.model';

export interface AutoDocDataModel {
    isExpand: boolean;
    clientDetails: ClientDetailsModel;
    years: YearDataModel[];
  }

export class DocsSortModel {
  name: string;
  value: number;
}

export const SORT_DOCS_LIST = [
  {
    'name': 'Newest on Top',
    'value': 1
  },
  {
    'name': 'Oldest on Top',
    'value': 2
  },
  {
    'name': 'Type',
    'value': 3
  },
  {
    'name': 'PDF',
    'value': 4
  },
  {
    'name': 'Excel',
    'value': 5
  },
  {
    'name': 'Word',
    'value': 6
  },
  {
    'name': 'JPEG',
    'value': 7
  }
];


// tab-type.model.ts
export enum TabType {
  ThisClient = 'thisClient',
  AllClients = 'allClients'
}

// folder-type.model.ts
export enum FolderType {
  SystemDocuments = 'systemDocuments',
  ManualDocuments = 'manualDocuments',
  FinalDocuments = 'finalDocuments'
}